import { RespuestaLecturaError } from './Mensajes';
import { llamadaAPI_DELETE, llamadaAPI_GET, llamadaAPI_POST } from './SQL';

export const function_TODOS_Dashboard_Permisos_ListarPorPersona = async (IdPersona) => {
    const NombreFuncion = "function_TODOS_Dashboard_Permisos_ListarPorPersona"

    try {        
        const resulData = await llamadaAPI_GET("TODOS_Dashboard_Permisos/ListarPorPersona/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" + 
            IdPersona);        

        return resulData; 
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_TODOS_Dashboard_Permisos_ListarPorFaltaPersona = async (IdPersona) => {
    const NombreFuncion = "function_TODOS_Dashboard_Permisos_ListarPorFaltaPersona"

    try {        
        const resulData = await llamadaAPI_GET("TODOS_Dashboard_Permisos/ListarPorFaltaPersona/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" + 
            IdPersona);        

        return resulData; 
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_TODOS_Dashboard_Items_Listar = async () => {
    const NombreFuncion = "function_TODOS_Dashboard_Items_Listar"

    try {
        const resulData = await llamadaAPI_GET("TODOS_Dashboard_Items/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));

        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_TODOS_Dashboard_Permisos_Insertar = async (IdItem, IdPersona) => {
    const NombreFuncion = "function_TODOS_Dashboard_Permisos_Insertar";

    try {
        await llamadaAPI_POST("TODOS_Dashboard_Permisos/InsertarCompleto/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdItem + "/" +
            IdPersona);
        return 1;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_TODOS_Dashboard_Permisos_Eliminar = async (IdItem, IdPersona) => {
    const NombreFuncion = "function_TODOS_Dashboard_Permisos_Eliminar"

    try {
        const resulData = await llamadaAPI_DELETE("TODOS_Dashboard_Permisos/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdItem + "/" +
            IdPersona);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};